<section class="detail-card" [attr.aria-label]="title">
  <header class="detail-card-header">
    <div class="detail-card-heading">
      <h3>
        @if (icon) { <mat-icon>{{ icon }}</mat-icon> }
        {{ title }}
        @if (subtitle) { <span class="detail-card-subtitle">{{ subtitle }}</span> }
      </h3>
    </div>
    <div class="detail-card-actions" role="group" [attr.aria-label]="'Acciones de ' + title"><ng-content select="[card-actions]"></ng-content></div>
  </header>
  <div class="detail-card-body">
    @if (isEmpty) {
      <div class="detail-card-empty-state" [class.detail-card-empty-state--illustrated]="emptyIcon || emptyDescription">
        @if (emptyIcon) { <mat-icon class="detail-card-empty-icon">{{ emptyIcon }}</mat-icon> }
        <div>
          <p class="detail-card-empty">{{ emptyMessage }}</p>
          @if (emptyDescription) { <p class="detail-card-empty-description">{{ emptyDescription }}</p> }
        </div>
      </div>
    }
    <div [hidden]="isEmpty"><ng-content></ng-content></div>
  </div>
  <footer class="detail-card-footer"><ng-content select="[card-footer]"></ng-content></footer>
</section>
